import { render, staticRenderFns } from "./Dimmer.vue?vue&type=template&id=f6d9e658&scoped=true"
import script from "./Dimmer.vue?vue&type=script&lang=js"
export * from "./Dimmer.vue?vue&type=script&lang=js"
import style0 from "./Dimmer.vue?vue&type=style&index=0&id=f6d9e658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d9e658",
  null
  
)

export default component.exports